import React, { useState, useEffect } from 'react';
import { View, TouchableOpacity, findNodeHandle, Platform } from 'react-native';
import { ActionSheet as ActionSheetNB, Button, Text } from 'native-base';

//import Icon from 'react-native-vector-icons/Ionicons';
import { Icon } from 'native-base';
import Modal from 'modal-enhanced-react-native-web';
/*


const dropdown = <PopupMenu
						actions={['item1','item2', 'item3']}
						icon={'user-add'}
						onPress={(e,i) => console.log(i)}
					/>
*/

export default function PopupMenu(props) {
	const [visible, setVisible] = useState(null);
	const ICON_SIZE = 22;

	const { color = 'white', padding = 15, paddingHorizontal, paddingVertical, ...restStyles } = props.style;
	const { actions, onPress, uri, destructiveButtonIndex = 2 } = props;
	const { icon = 'md-more' } = props;
	return (
		<View>
			{props.children}
			<TouchableOpacity
				onPress={() => {
					setVisible(true);
				}}
				style={{ flex: 1, alignItems: 'center', alignSelf: 'center', backgroundColor: 'transparent', padding, paddingHorizontal, paddingVertical }}>
				<Icon name={icon} style={{ color, fontSize: ICON_SIZE }} />
			</TouchableOpacity>
			<Modal
				//animationIn="slideInUp"
				//animationOut="slideOutDown"
				animationType="fade"
				backdropColor="#556"
				isVisible={visible}
				backdropPressToClose
				backButtonClose
				coverScreen
				onBackdropPress={() => {
					setVisible(false);
				}}
				presentationStyle="overFullScreen"
				animationType="slide"
				swipeDirection="down"
				style={{
					width: 300,
					margin: 'auto'
				}}>
				<View
					style={{
						alignItems: 'center',
						width: 300,
						height: 'auto',
						flexDirection: 'column',
						alignItems: 'center',
						justifyContent: 'center',
						borderRadius: 10,
						backgroundColor: 'rgba(255,255,255,0.5)'
					}}>
					{actions.map((v, i) => (
						<Button
							full
							style={[{ margin: 5, alignContent: 'center', borderRadius: 5 }, destructiveButtonIndex == i && { backgroundColor: '#9c3c3c' }]}
							key={i}
							onPress={() => {
								setVisible(false);
								onPress(v, i);
							}}>
							<Text color="#FFF">{v}</Text>
						</Button>
					))}
				</View>
			</Modal>
		</View>
	);
}
